import { TDR, querySnapshotToArray } from 'tdr-common';
import { collection, getDocs, getFirestore, limit, query, where } from 'firebase/firestore';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';

const CACHE_SETTINGS = {
	staleTime: 5 * 60 * 1000, // 5 minutes - feature flags rarely change
	gcTime: 10 * 60 * 1000, // 10 minutes - keep in cache
	refetchOnMount: false,
	refetchOnWindowFocus: false
};

export function useFeatureFlags(restaurantId: string) {

	const query = useQuery({
		enabled: !!restaurantId,
		queryKey: ['restaurantFeatureFlags', restaurantId],
		queryFn: () => getRestaurantFeatureFlags(restaurantId),
		...CACHE_SETTINGS
	});

	return query;
}

/**
 * Hook for fetching restaurant feature flags with React Suspense
 * Use this in components wrapped with <Suspense> for automatic loading states
 * @throws {Promise} Suspends while loading
 */
export function useFeatureFlagsSuspense(restaurantId: string) {
	const query = useSuspenseQuery({
		queryKey: ['restaurantFeatureFlags', restaurantId],
		queryFn: () => getRestaurantFeatureFlags(restaurantId),
		...CACHE_SETTINGS
	});

	return query;
}

export async function getRestaurantFeatureFlags (restaurantId: string): Promise<TDR.FeatureFlags> {
	const db = getFirestore();
	const q = query(collection(db, 'FeatureFlags'), where('restaurantId', '==', restaurantId), limit(1));
	const querySnapshot = await getDocs(q);
	return querySnapshotToArray(querySnapshot)?.[0] || null;
}